module.exports = __webpack_public_path__ + "assets/images/typeofcar-04.20ed66cbfa8ae27f5ae9972b516800e7.svg";